import Model from './model'

export default class Booking extends Model {
  constructor() {
    super()
    this.hydrate({
      id: null,
      alcohol: '',
      approved: false,
      booking_number: '',
      created_at: '',
      display_payment_amount: '',
      display_total: '',
      event: '',
      expected_persons: 0,
      invoice: '',
      payment_amount: 0,
      payment_method_id: '',
      payment_received: '',
      rejected: '',
      special_instructions: '',
      extras: [],
      deposits: [],
      user: {
        profile: {}
      },
      slots: [],
      slot_fees: [],
      current_status: {},
      payment_method: {},
      additional_billing_invoice: {
        items: []
      },
      approved_by: {},
      rejected_by: {},
      payment_captured_by: {}
    })
  }
}
